import React from 'react';
import { translate } from 'react-jhipster';
import { Button } from 'reactstrap';
import './claim-declare-step-actions.scss';

const StepActionsVertical = (props) => {
    const { getNextView, disabledNext } = props;
    return (
        <div className="row-buttonRow">
            <div className="content-stepActionsVertical" >
                <Button tabIndex={0}
                    onClick={getNextView}
                    className="button"
                    disabled={disabledNext}>
                    <span>{translate("settings.button.valid")}</span>
                </Button>
            </div>
        </div>
    );
};


export default StepActionsVertical;
